import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export function createRouter() {
    return new Router({
        mode: 'history', // 'hash',
        fallback: false,
        scrollBehavior: () => ({ y: 0 }),
        routes: [
            {
                path: '/privacy',
                component: () => import('../views/privacy/index.vue')
            },
            {
                path: '/leads',
                component: () => import('../views/leads/index.vue')
            },
            {
                path: '/driver',
                component: () => import('../views/driver/index.vue')
            },
            {
                path: '/marketing/:lpid',
                component: () => import('../views/marketing/index.vue')
            },
            {
                path: '/guide/:gpid',
                component: () => import('../views/marketing/guide.vue')
            },
            {
                path: '/notice',
                component: () => import('../views/driver/notice.vue')
            },
            {
                path: '/f/qr',
                component: () => import('../views/error/qr.vue')
            },
            {
                path: '/report/fellow',
                component: () => import('../views/report/fellow.vue')
            },
            {
                path: '/error',
                component: () => import('../views/error/index.vue')
            }
        ]
    });
}



// WEBPACK FOOTER //
// ./src/router/index.js